export const FEATURES_TAB_REQUEST = "FEATURES_TAB_REQUEST";
export const FEATURES_TAB_RESULT = "FEATURES_TAB_RESULT";